import { useEffect, useRef, useState } from "react";
import CountUp from "react-countup";
import { useLanguage } from "@/i18n/LanguageContext";

export default function StatsBar() {
  const { t } = useLanguage();
  const [visible, setVisible] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const obs = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          obs.disconnect();
        }
      },
      { threshold: 0.3 }
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, []);

  return (
    <section
      id="stats"
      ref={ref}
      data-testid="stats-bar"
      className="relative bg-ink-soft border-y border-ink-line"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-20">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-10 md:gap-8">
          {t.stats.map((s, i) => (
            <div
              key={s.label}
              className="text-center md:text-left md:border-l md:border-ink-line md:first:border-l-0 md:pl-8 first:pl-0"
            >
              <div
                className="font-heading text-5xl md:text-6xl lg:text-7xl text-white leading-none"
                data-testid={`stat-${i}`}
              >
                {s.prefix}
                {visible ? <CountUp end={s.value} duration={2.2} /> : s.value}
                <span className="text-gold">{s.suffix}</span>
              </div>
              <div className="mt-3 text-xs md:text-sm uppercase tracking-[0.2em] text-white/60 font-semibold">
                {s.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
